import { inject } from "vue";
import { useListingArrayModel } from "./useListingArrayModel";
import { transformFaqsToApi } from "../utils/transformers/contentTransformers";
import type { Faq } from "../types/listingModels";
import { ListingFaqsStoreKey } from "./listingStoreKeys";

export function createListingFaqsStore() {
    const arrayModel = useListingArrayModel<Faq>();

    function getPublishable() {
        return transformFaqsToApi(arrayModel.model.value);
    }

    return {
        model: arrayModel.model,
        initial: arrayModel.initial,
        isDirty: arrayModel.isDirty,
        add: arrayModel.add,
        updateAt: arrayModel.updateAt,
        removeAt: arrayModel.removeAt,
        reorder: arrayModel.reorder,
        markSaved: arrayModel.markSaved,
        resetAll: arrayModel.resetAll,
        getPublishable,
    };
}

export function useListingFaqsStore() {
    const store = inject(ListingFaqsStoreKey);
    if (!store) {
        throw new Error('useListingFaqsStore must be used within a component that provides ListingFaqsStoreKey');
    }
    return store;
}

